import http from '../utils/http-common'

const getAll = (param) => {
  return http.get('/weights', { params: param })
}
const WeightClassDataService = {
  getAll,
}
export default WeightClassDataService
